import { ThemeProvider } from '@mui/material/styles';
import React from 'react';
import { uplift } from './themes';
import { GlobalLocalizationProvider } from './GlobalLocalizationProvider';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { TssCacheProvider } from 'tss-react';


const MUIEmotionInsertionPoint = document.createElement('meta');

MUIEmotionInsertionPoint.setAttribute('name', 'mui-emotion-insertion-point');
MUIEmotionInsertionPoint.setAttribute('content', '');
document.head.appendChild(MUIEmotionInsertionPoint);
const muiCache = createCache({
  key: 'mui',
  insertionPoint: MUIEmotionInsertionPoint,
});


const TSSEmotionInsertionPoint = document.createElement('meta');

TSSEmotionInsertionPoint.setAttribute('name', 'tss-emotion-insertion-point');
TSSEmotionInsertionPoint.setAttribute('content', '');
document.head.appendChild(TSSEmotionInsertionPoint);
const tssCache = createCache({
  key: 'tss',
  insertionPoint: TSSEmotionInsertionPoint,
});


export const UpliftThemeProvider: React.FC = ({ children }) => (
  <GlobalLocalizationProvider>
    <CacheProvider value={muiCache}>
      <TssCacheProvider value={tssCache}>
        <ThemeProvider theme={uplift}>
          {children}
        </ThemeProvider>
      </TssCacheProvider>
    </CacheProvider>
  </GlobalLocalizationProvider>
);


export const withUpliftTheme = <TProps extends Record<string, unknown>>(WrappedComponent: React.ComponentType<TProps>) =>
  (props: TProps) => (
    <UpliftThemeProvider>
      <WrappedComponent {...props} />
    </UpliftThemeProvider>
  );
